import Marquee from "react-fast-marquee";

const WORDS = ["CLEANOUTS", "DEEP CLEAN", "ORGANIZATION", "JUNK REMOVAL", "SHELVING", "LIGHTING", "HAUL-AWAY", "PEGBOARDS"];

export const Ribbon = () => (
  <section className="bg-rust text-white py-5 border-y border-ink/10">
    <Marquee speed={45} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="mx-8 font-display font-extrabold text-xl uppercase tracking-wide flex items-center gap-8">
          {w} <span className="text-white/50">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
